let loaded = false
let warnedMissingId = false

export function loadGtm(): void {
  if (!import.meta.env.PROD) return

  const containerId = import.meta.env.VITE_GTM_ID
  if (!containerId) {
    if (!warnedMissingId) {
      console.warn('[gtm] VITE_GTM_ID missing in production')
      warnedMissingId = true
    }
    return
  }

  if (loaded) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
  document.head.insertBefore(script, document.head.firstChild)

  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.prepend(noscript)

  loaded = true
}
